/* eslint-disable */
import * as Types from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import { RichTextBlockEntryFragmentDoc, RichTextHyperlinkEntryFragmentDoc, RichTextBlockAssetFragmentDoc } from '../../../lib/copyRendering.generated';
import { ReviewAggregationCollectionFragmentDoc } from '../../../lib/reviewAggregation.generated';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient } from 'lib/apollo';
const defaultOptions = {} as const;
export type AgentQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type AgentQuery = { __typename?: 'Query', agentCollection?: { __typename?: 'AgentCollection', items: Array<{ __typename?: 'Agent', name?: string | null, slug?: string | null, city?: string | null, county?: string | null, phoneNumber?: string | null, email?: string | null, businessCardUrl?: string | null, velocifyId?: number | null, under65Redirect?: string | null, over65Redirect?: string | null, dentalRedirect?: string | null, active?: boolean | null, calendlyUrl?: string | null, calendlyUrlFullCalendarOverride?: string | null, products?: Array<string | null> | null, insuranceCarrier?: Array<string | null> | null, languages?: Array<string | null> | null, licensedYear?: number | null, sys: { __typename?: 'Sys', id: string }, photo?: { __typename?: 'Asset', description?: string | null, url?: string | null, width?: number | null, height?: number | null } | null, biography?: { __typename?: 'AgentBiography', json: any, links: { __typename?: 'AgentBiographyLinks', entries: { __typename?: 'AgentBiographyEntries', block: Array<{ __typename?: 'Agent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AgentBadge', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Article', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArticleCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'City', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'County', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Plan', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Review', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Snippet', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SnippetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SnippetList', key?: string | null, items?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Agent', slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AgentBadge', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Article', slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArticleCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'City', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'County', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Plan', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Review', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Snippet', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SnippetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SnippetList', sys: { __typename?: 'Sys', id: string } } | null> }, assets: { __typename?: 'AgentBiographyAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null, badgesCollection?: { __typename?: 'AgentBadgesCollection', items: Array<{ __typename?: 'AgentBadge', year?: number | null, name?: string | null, description?: string | null, image?: { __typename?: 'Asset', description?: string | null, url?: string | null, width?: number | null, height?: number | null } | null } | null> } | null } | null> } | null, reviewAggregationCollection?: { __typename?: 'ReviewCollection', total: number, items: Array<{ __typename?: 'Review', starRating?: number | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type AgentReviewsQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type AgentReviewsQuery = { __typename?: 'Query', reviewCollection?: { __typename?: 'ReviewCollection', items: Array<{ __typename?: 'Review', name?: string | null, starRating?: number | null, date?: any | null, content?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type AgentSlugsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentSlugsQuery = { __typename?: 'Query', agentCollection?: { __typename?: 'AgentCollection', items: Array<{ __typename?: 'Agent', slug?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null };


export const AgentDocument = gql`
    query Agent($slug: String!) {
  agentCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
      name
      slug
      photo {
        description
        url(
          transform: {width: 600, height: 600, resizeStrategy: FILL, resizeFocus: FACE}
        )
        width
        height
      }
      city
      county
      phoneNumber
      email
      businessCardUrl
      velocifyId
      under65Redirect
      over65Redirect
      dentalRedirect
      active
      calendlyUrl
      calendlyUrlFullCalendarOverride
      biography {
        json
        links {
          entries {
            block {
              ...RichTextBlockEntry
            }
            hyperlink {
              ...RichTextHyperlinkEntry
            }
          }
          assets {
            block {
              ...RichTextBlockAsset
            }
          }
        }
      }
      products
      insuranceCarrier
      languages
      licensedYear
      badgesCollection {
        items {
          year
          name
          description
          image {
            description
            url(transform: {width: 400, height: 400, resizeStrategy: FIT})
            width
            height
          }
        }
      }
    }
  }
  reviewAggregationCollection: reviewCollection(
    order: date_DESC
    limit: 1000
    where: {agent: {slug: $slug}}
  ) {
    ...ReviewAggregationCollection
  }
}
    ${RichTextBlockEntryFragmentDoc}
${RichTextHyperlinkEntryFragmentDoc}
${RichTextBlockAssetFragmentDoc}
${ReviewAggregationCollectionFragmentDoc}`;

/**
 * __useAgentQuery__
 *
 * To run a query within a React component, call `useAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAgentQuery(baseOptions: Apollo.QueryHookOptions<AgentQuery, AgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentQuery, AgentQueryVariables>(AgentDocument, options);
      }
export function useAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentQuery, AgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentQuery, AgentQueryVariables>(AgentDocument, options);
        }
export type AgentQueryHookResult = ReturnType<typeof useAgentQuery>;
export type AgentLazyQueryHookResult = ReturnType<typeof useAgentLazyQuery>;
export type AgentQueryResult = Apollo.QueryResult<AgentQuery, AgentQueryVariables>;
export const AgentReviewsDocument = gql`
    query AgentReviews($slug: String!, $skip: Int = 0, $limit: Int = 3) {
  reviewCollection(
    order: date_DESC
    where: {agent: {slug: $slug}}
    limit: $limit
    skip: $skip
  ) {
    items {
      sys {
        id
      }
      name
      starRating
      date
      content
    }
  }
}
    `;

/**
 * __useAgentReviewsQuery__
 *
 * To run a query within a React component, call `useAgentReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentReviewsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAgentReviewsQuery(baseOptions: Apollo.QueryHookOptions<AgentReviewsQuery, AgentReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentReviewsQuery, AgentReviewsQueryVariables>(AgentReviewsDocument, options);
      }
export function useAgentReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentReviewsQuery, AgentReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentReviewsQuery, AgentReviewsQueryVariables>(AgentReviewsDocument, options);
        }
export type AgentReviewsQueryHookResult = ReturnType<typeof useAgentReviewsQuery>;
export type AgentReviewsLazyQueryHookResult = ReturnType<typeof useAgentReviewsLazyQuery>;
export type AgentReviewsQueryResult = Apollo.QueryResult<AgentReviewsQuery, AgentReviewsQueryVariables>;
export const AgentSlugsDocument = gql`
    query AgentSlugs {
  agentCollection {
    items {
      sys {
        id
      }
      slug
    }
  }
}
    `;

/**
 * __useAgentSlugsQuery__
 *
 * To run a query within a React component, call `useAgentSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentSlugsQuery(baseOptions?: Apollo.QueryHookOptions<AgentSlugsQuery, AgentSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentSlugsQuery, AgentSlugsQueryVariables>(AgentSlugsDocument, options);
      }
export function useAgentSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentSlugsQuery, AgentSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentSlugsQuery, AgentSlugsQueryVariables>(AgentSlugsDocument, options);
        }
export type AgentSlugsQueryHookResult = ReturnType<typeof useAgentSlugsQuery>;
export type AgentSlugsLazyQueryHookResult = ReturnType<typeof useAgentSlugsLazyQuery>;
export type AgentSlugsQueryResult = Apollo.QueryResult<AgentSlugsQuery, AgentSlugsQueryVariables>;
export async function getServerPageAgent
    (options: Omit<Apollo.QueryOptions<AgentQueryVariables>, 'query'>, ctx?: any ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<AgentQuery>({ ...options, query: AgentDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export type PageAgentComp = React.FC<{data?: AgentQuery, error?: Apollo.ApolloError}>;
export const ssrAgent = {
      getServerPage: getServerPageAgent,
      
      
    }
export async function getServerPageAgentReviews
    (options: Omit<Apollo.QueryOptions<AgentReviewsQueryVariables>, 'query'>, ctx?: any ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<AgentReviewsQuery>({ ...options, query: AgentReviewsDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export type PageAgentReviewsComp = React.FC<{data?: AgentReviewsQuery, error?: Apollo.ApolloError}>;
export const ssrAgentReviews = {
      getServerPage: getServerPageAgentReviews,
      
      
    }
export async function getServerPageAgentSlugs
    (options: Omit<Apollo.QueryOptions<AgentSlugsQueryVariables>, 'query'>, ctx?: any ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<AgentSlugsQuery>({ ...options, query: AgentSlugsDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export type PageAgentSlugsComp = React.FC<{data?: AgentSlugsQuery, error?: Apollo.ApolloError}>;
export const ssrAgentSlugs = {
      getServerPage: getServerPageAgentSlugs,
      
      
    }